module.exports = __webpack_public_path__ + "static/media/poppins-700.0bd523f6.woff2";